(function () {
  function animatePanel(panel, open) {
    if (!panel) return;
    var targetHeight = panel.scrollHeight;

    if (open) {
      panel.style.maxHeight = "0px";
      requestAnimationFrame(function () {
        panel.style.maxHeight = targetHeight + "px";
      });
      return;
    }

    panel.style.maxHeight = targetHeight + "px";
    requestAnimationFrame(function () {
      panel.style.maxHeight = "0px";
    });
  }

  function setItemOpen(item, open, animate) {
    var trigger = item.querySelector("[data-faq-trigger]");
    var panel = item.querySelector("[data-faq-panel]");
    item.classList.toggle("is-open", open);
    if (trigger) trigger.setAttribute("aria-expanded", open ? "true" : "false");

    if (!panel) return;

    if (animate === false) {
      panel.style.maxHeight = open ? panel.scrollHeight + "px" : "0px";
      return;
    }

    animatePanel(panel, open);
  }

  function initSection(section) {
    if (!section || section.getAttribute("data-faq-ready") === "true") return;

    var items = Array.prototype.slice.call(section.querySelectorAll("[data-faq-item]"));
    if (!items.length) return;

    section.setAttribute("data-faq-ready", "true");

    items.forEach(function (item) {
      setItemOpen(item, false, false);
    });

    section.addEventListener("click", function (event) {
      var trigger = event.target.closest("[data-faq-trigger]");
      if (!trigger || !section.contains(trigger)) return;

      var item = trigger.closest("[data-faq-item]");
      if (!item) return;

      var isOpen = item.classList.contains("is-open");

      items.forEach(function (other) {
        if (other !== item && other.classList.contains("is-open")) {
          setItemOpen(other, false);
        }
      });

      setItemOpen(item, !isOpen);
    });
  }

  function initAll(root) {
    var scope = root || document;
    var sections = scope.querySelectorAll
      ? scope.querySelectorAll("[data-custom-faq]")
      : [];

    if (scope.matches && scope.matches("[data-custom-faq]")) {
      initSection(scope);
    }

    Array.prototype.forEach.call(sections, initSection);
  }

  initAll();

  document.addEventListener("shopify:section:load", function (event) {
    initAll(event.target);
  });
})();
